<div class="ti-cnt" [ngClass]="{'no-margin': noMargin, 'no-min-width': noMinWidth}">
  <span *ngIf="labelText && !hideLabel" class="ti-label" [ngClass]="{'ti-span-error': isRequired && !isValid}">
    {{labelText}} <span *ngIf="isRequired">*</span>
  </span>

  <div class="input-wrapper">
    <input class="ti-input" [placeholder]="'W00-YY'" [value]="displayValue" readonly
      [ngClass]="{'ti-readonly': readOnly || disabled, 'ti-input-mobile': isMobile, 'ti-input-error': isRequired && !isValid}"
      (click)="openPicker()">
    <i class="fas fa-calendar-day ico-calendar" [ngClass]="{'ico-disabled': readOnly || disabled}" (click)="openPicker()"></i>

    <mat-date-range-input [rangePicker]="picker" class="hidden-range-input" [disabled]="disabled || readOnly" [min]="minDate">
      <input matStartDate (dateChange)="onDateChange($event.value)">
      <input matEndDate (dateChange)="onDateChange($event.value)">
    </mat-date-range-input>
    <mat-date-range-picker #picker  [startAt]="selectedDate || minDate || startAtDate"></mat-date-range-picker>
  </div>
</div>
